module.exports = __webpack_public_path__ + "static/footer-one-way-romania-260f79f1e63453c3dbe6886ae6b9f6dc.png";